<template lang="pug">
    v-btn.crud-create-button(v-bind="buttonProps" @click="action()" large) 
        v-icon.pr-2 {{icon}}
        span.font-weight-bold {{text}}
</template>

<script>
export default {
    name: 'crud-create-button',
    props: {
        action: {
            type: Function,
            default: () => {console.log('a')}
        },
        text: {
            type: String,
            default: () => 'CREAR'
        },
        icon: {
            type: String,
            default: () => 'add_circle'
        },
        buttonProps: {
            type: Object,
            default: () => {
                return {
                    color: 'accent'
                }
            }
        }
    },
    data: function(){
        return {}
    },
    computed: {},
    methods: {},
    watch: {},
    components: {},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
    .crud-create-button{
        position: fixed;
        top: 3px;
        right: 140px;
        z-index: 30;
    }
</style>
